import React from 'react';
import Box from '@material-ui/core/Box';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Typography, makeStyles } from '@material-ui/core';
import Button from 'components/common/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    marginBottom: theme.spacing(1),
  },
  summary: {
    background: theme.palette.background.default,
  },
  details: {
    border: '1px solid rgba(105, 109, 117, 0.15)',
  },
}));

const FAMILY_INCOME = [
  ['$0-$30,000', '0-30000'],
  ['$30,000-$48,000', '30001-48000'],
  ['$48,000-$75000', '48001-75000'],
  ['$75,000-$110,00', '750001-111000'],
  ['$110,000+', '110001-plus'],
];

const Costs = ({ school }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          className={classes.summary}
          IconButtonProps={{
            edge: 'start',
            color: 'inherit',
          }}
        >
          <Typography variant="body2">Costs</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <Box
            padding={2}
            flex={1}
          >
            <Typography variant="body2">
              Average Annual Cost
            </Typography>
            <Typography
              paragraph
              variant="caption"
            >
              Cost includes tuition, living costs, books, and fees.
            </Typography>
            <Typography paragraph variant="h3">
              {school['latest.cost.avg_net_price.overall'] ||
              school['latest.cost.tuition.program_year'] ? (
                <>
                  $
                  {school[
                    'latest.cost.avg_net_price.overall'
                  ]?.toLocaleString() ||
                    school[
                      'latest.cost.tuition.program_year'
                    ]?.toLocaleString()}
                </>
              ) : 'Data Not Available'}
            </Typography>
            <Typography
              variant="body2"
            >
              Personal Net Price
            </Typography>
            <Typography
              variant="caption"
            >
              Institutions provide a custom net price calculator.
            </Typography>
            <Box textAlign="center" marginTop={4}>
              <Button
                size="large"
                color="primary"
                variant="contained"
                onClick={() =>
                  window.open(`http://${school['school.price_calculator_url']}`)
                }
              >
                Calculate your Personal Net Price
              </Button>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Costs;
